import React from 'react';
import { Logo } from '../../Logo';
import Link from 'next/link';
import { getActiveLocale } from '@/utils/active-locale';

export const LogoLink = () => {
  const activeLocale = getActiveLocale();
  return (
    <Link href={`/${activeLocale}`} className='flex lg:flex-1'>
      <div className='-m-1.5 p-1.5 h-full cursor-pointer flex items-center gap-4'>
        <span className='sr-only'>Your Company</span>
        <div className='w-10'>
          <Logo />
        </div>
      </div>
    </Link>
  );
};
